import LegalLayout from "@/components/legal/legal-layout"
import content from "@/content/legal/terminos.md?raw"

export default function Terms() {
  return <LegalLayout title="Términos y Condiciones" content={content} />
}
